const makeGetRequest = async (url: string): Promise<Response> => {
  return await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export default makeGetRequest;
